import { FC } from 'react';
import { Box } from '@mui/material';

import { DashboardStatistics, CampaignStatistics } from '@carcareers/components';

export const Home: FC = () => {
  return (
    <Box>
      <Box sx={{ p: 2 }}>
        <DashboardStatistics />
      </Box>
    </Box>
  );
};

export default Home;
